/**
 * Règles de présence en partie pour le « ne pas déranger » et les invitations.
 *
 * - Live : toujours contre des robots
 * - Différé individuel / rétro : toujours contre des robots
 * - Différé triplette ou équipe (diff_tq) : humains présents
 * - Autres modes (libre, défi, neo…) : déterminé par l'état de la table
 */

import type { GameConnectionInfo } from '../types/app';

/**
 * Indique si la partie en cours est uniquement contre des robots.
 * `undefined` = inconnu (attendre l'état de la table).
 */
export function isBotsOnlyGame(
  gameInfo: GameConnectionInfo,
  fromGameState?: boolean,
): boolean | undefined {
  if (gameInfo.retroDiffere) return true;
  if (gameInfo.idserv === 'live') return true;
  if (gameInfo.idserv === 'diff_indiv') return true;
  if (gameInfo.idserv === 'diff_tq') return false;
  return fromGameState === undefined ? undefined : !fromGameState;
}

/** Inverse de isBotsOnlyGame pour le contexte existant. */
export function computeHasOtherHumansForDnd(
  gameInfo: GameConnectionInfo,
  fromGameState?: boolean,
): boolean | undefined {
  const botsOnly = isBotsOnlyGame(gameInfo, fromGameState);
  if (botsOnly === undefined) return undefined;
  return !botsOnly;
}
